import { TransactionHistoryRequestModel } from "app/based/baseApiModel/baseTransactionHistory/TransactionHistoryRequestModel";

export class PackageRegistrationQueryEntity extends TransactionHistoryRequestModel {
  code?: string;
  carrierCode?: Array<string>;
  limit?: number;
  page?: number;
  pagination?: boolean;
  phoneNumber?: string;
  status?: number;
  package?: string;
  packageCode?: Array<string>;
  created?: Record<string, unknown>[];
  fromDate?: string;
  toDate?: string;
  storeCodes?: Array<string>;
  staff?: Array<string>;
  partnerCodes?: Array<string>;
  order?: string;
  isOnlyStore?: string;
  providerCode?: string;
  userRef?: Array<string>;
  serviceCode?: string;
  transRef?: string;
  userPhone?: string;
  supplierRefCode?: string;

  constructor(data?: Partial<PackageRegistrationQueryEntity>) {
    super();
    this.status = data?.status;
    this.code = data?.code;
    this.carrierCode = data?.carrierCode;
    this.phoneNumber = data?.phoneNumber;
    this.page = data?.page;
    this.limit = data?.limit;
    this.pagination = data?.pagination;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.fromDate = data?.fromDate;
    this.package = data?.package;
    this.created = data?.created;
    this.storeCodes = data?.storeCodes;
    this.staff = data?.staff;
    this.partnerCode = data?.partnerCode;
    this.order = data?.order;
    this.isOnlyStore = data?.isOnlyStore;
    this.providerCode = data?.providerCode;
    this.partnerCodes = data?.partnerCodes;
    this.userRef = data?.userRef;
    this.serviceCode = data?.serviceCode;
    this.packageCode = data?.packageCode;
    this.transRef = data?.transRef;
    this.userPhone = data?.userPhone;
    this.supplierRefCode = data?.supplierRefCode;
  }
}
